import { render, staticRenderFns } from "./UOMForm.vue?vue&type=template&id=a839c936"
import script from "./UOMForm.vue?vue&type=script&lang=js"
export * from "./UOMForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports